import { doc, onSnapshot, Timestamp } from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../storeHooks";
import { fireStore } from "../../firebase";
import { iUserDetails } from "../../types/userType";

export const useOnUpdateUserEvents = (
  shouldStartUpdating: boolean,
  callback: () => void
) => {
  const user = useAppSelector(
    (state) => state.user?.userDetails as iUserDetails
  );
  const [eventUpdated, setEventUpdated] = useState<Timestamp | null>(null);
  const ref = useRef(0);

  useEffect(() => {
    let unsubscribe: () => void;
    if (fireStore && user?.id) {
      const documentRef = doc(fireStore, "vendors", user.id);

      unsubscribe = onSnapshot(documentRef, (doc) => {
        if (doc.exists()) {
          if (shouldStartUpdating) {
            setEventUpdated(doc.data().eventsUpdatedAt);
            ref.current += 1;
          }
        }
      });
    }
    return () => unsubscribe && unsubscribe();
  }, [shouldStartUpdating]);

  useEffect(() => {
    if (eventUpdated && shouldStartUpdating && ref.current >= 2) {
      callback();
    }
  }, [eventUpdated]);
};
